import JPageFloating from './Control_Charts'
export { JPageFloating }
export default JPageFloating